<!--出库报表-->
<template>
	<div>
		<h3>出库报表</h3>
		<div class="content">
			<div class="item">
				<el-form ref="form" :model="form" inline :rules="rules" label-width="100px">
					<el-form-item label="出库单号" prop="OutboundOrder.Order" clearable>
						<el-input  v-model="form.OutboundOrder.Order" clearable></el-input>
					</el-form-item>
                    <el-form-item label="商品名称" prop="Productname">
						<el-input placeholder="全部商品" v-model="form.Productname" @focus="productfocus" clearable @clear="setProductNull"></el-input>
					</el-form-item>
					<el-form-item label="发货单位" prop="StoreName">
						<el-input placeholder="全部仓库" v-model="form.StoreName" @focus="storefocus" clearable @clear="setStoreNull"></el-input>
					</el-form-item>
                    <el-form-item label="收货单位" prop="DealerName">
						<el-input placeholder="全部经销商" v-model="form.DealerName" @focus="dealerfocus" clearable @clear="setDealerNull"></el-input>
					</el-form-item>
                    <el-form-item label="出库类型" prop="OutboundOrder.OutType">
						<el-select v-model="form.OutboundOrder.OutType" placeholder="请选择出库状态" clearable>
							<el-option
							v-for="item in DeliveryType"
							:key="item.type"
							:label="item.storage"
							:value="item.type">
							</el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="出库日期" prop="outTime">
                        <el-date-picker
                        v-model="form.outTime"
                        type="daterange"
                        range-separator="-"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期" clearable>
                        </el-date-picker>
					</el-form-item>
				</el-form>
				<span style="margin: 0 0 20px 100px;">
                    <el-button type="primary" @click="SeloutData">搜 索</el-button>
					<el-button @click="restForm" type="warning">重 置</el-button>
				</span>
			</div>
            <el-dialog title="选择商品" :visible.sync="productVisible" width="600px">
                <el-table :data="productData" highlight-current-row>
                    <el-table-column align="center" width="80" property="DataId"></el-table-column>
                    <el-table-column align="center" width="80" property="Productcode" label="商品编号"></el-table-column>
                    <el-table-column align="center" width="200" property="Productname" label="商品名称"></el-table-column>
                    <el-table-column align="center" width="200" label="操作">
                        <template slot-scope="scope">
                             <el-button type="primary" @click="productconfirm(scope)">选 择</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </el-dialog>
			<el-dialog title="选择仓库" :visible.sync="storeVisible" width="600px">
                <el-table :data="stroeData" highlight-current-row>
                    <el-table-column align="center" width="80" property="DataId"></el-table-column>
                    <el-table-column align="center" width="80" property="StoreCode" label="仓库编号"></el-table-column>
                    <el-table-column align="center" width="200" property="StoreName" label="仓库名称"></el-table-column>
                    <el-table-column align="center" width="200" label="操作">
                        <template slot-scope="scope">
                             <el-button type="primary" @click="storeconfirm(scope)">选 择</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </el-dialog>
			<el-dialog title="选择经销商" :visible.sync="dealerVisible" width="600px">
                <el-table :data="dealerData" highlight-current-row>
                    <el-table-column align="center" width="80" property="DataId"></el-table-column>
                    <el-table-column align="center" width="80" property="DealerId" label="经销商编号"></el-table-column>
                    <el-table-column align="center" width="200" property="DealerName" label="经销商名称"></el-table-column>
                    <el-table-column align="center" width="200" label="操作">
                        <template slot-scope="scope">
                             <el-button type="primary" @click="dealerconfirm(scope)">选 择</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </el-dialog>
		</div>
		<div class="item">
			<el-table :data="tableData" highlight-current-row border>
				<el-table-column align="center" property="Order"  label="出库单号"></el-table-column>
				<el-table-column align="center" property="OutTime" :formatter="date_string" label="出库时间"></el-table-column>
				<el-table-column align="center" property="OutType" label="出库类型"></el-table-column>
				<el-table-column align="center" property="ProductCodeName" label="商品名称"></el-table-column>
				<el-table-column align="center" property="SpecName" label="商品规格"></el-table-column>
				<el-table-column align="center" property="PNums" label="计划数量"></el-table-column>
				<el-table-column align="center" property="FNums" label="实际数量"></el-table-column>
				<el-table-column align="center" property="ShipperName" label="发货单位"></el-table-column>
				<el-table-column align="center" property="ReceiverName" label="收货单位"></el-table-column>
				<el-table-column align="center" property="Status" label="订单状态"></el-table-column>
				<el-table-column align="center" property="Remark" label="详情"></el-table-column>
			</el-table>
			<el-pagination
			background
			@current-change="handleCurrentChange"
			layout="total,prev, pager, next,jumper"
			:total="pageNum"
			:page-size="10">
			</el-pagination>
		</div>
	</div>
</template>

<script>
export default {
	data(){
		return {
			form:{
				OutboundOrder:{
					Productcode:'',
					Order:'',
					ShipperId:'',
					ReceiverId:'',
					OutType:'',
				},
				outTime:'',
				pageIndex:1,
				Productname:'',
				StoreName:'',
				DealerName:''
			},
			rules: {
        		outTime:[
          			{ required: true, message: '请选择时间', trigger: 'change' }
        		]
			},
			productData:[],
			stroeData:[],
			dealerData:[],
			DeliveryType:[{
				type:'XSCK',
				storage:"销售出库"
			},{
				type:'XHCK',
				storage:"销毁出库"
			},{
				type:'DBCK',
				storage:"调拨出库"
			}],
			tableData: [],
			pageNum:0,
			productVisible: false,
			storeVisible: false,
			dealerVisible: false
		};
	},
	mounted : function(){
		this.getProduct()
		this.getStore()
		this.getDealer()
	},
	methods: {
		getProduct(){
			var user = JSON.parse(sessionStorage.getItem('user'));
			this.$axios({
				method: 'post',
				url:'/FW/Product.ashx',
				params: {
					action:"query",
					cid:user.QyNum
				}
				}).then(res=>{
				if(res.Code==0){
					this.productData=res.DataList;
				}else{
					this.$message({
					showClose: true,
					message: res.Msg,
					type: "warning"
					});
				}      
			})
		},
		productfocus(){//获取商品
			this.productVisible=true;
		},
		productconfirm(scope){ //选中商品
			this.form.OutboundOrder.Productcode = scope.row.Productcode;
			this.form.Productname = scope.row.Productname;
			this.productVisible = false
		},
		setProductNull(){
			this.form.OutboundOrder.Productcode = '';
		},

		getStore(){
			var user = JSON.parse(sessionStorage.getItem('user'));
			this.$axios({
				method: 'post',
				url:'/FW/Store.ashx',
				params: {
					action:"query",
					cid:user.QyNum
				}
				}).then(res=>{
				if(res.Code==0){
					this.stroeData=res.DataList;
				}else{
					this.$message({
					showClose: true,
					message: res.Msg,
					type: "warning"
					});
				}      
			})
		},
		storefocus(){//获取仓库
			this.storeVisible=true;	
		},
		storeconfirm(scope){ //选中仓库
			this.form.OutboundOrder.ShipperId = scope.row.StoreCode;
			this.form.StoreName = scope.row.StoreName;
			this.storeVisible = false
		},
		setStoreNull(){
			this.form.OutboundOrder.ShipperId = '';
		},

		getDealer(){
			var user = JSON.parse(sessionStorage.getItem('user'));
			this.$axios({
				method: 'post',
				url:'/FW/Dealer.ashx',
				params: {
					action:"query",
					cid:user.QyNum
				}
				}).then(res=>{
				if(res.Code==0){
					this.dealerData=res.DataList;
				}else{
					this.$message({
					showClose: true,
					message: res.Msg,
					type: "warning"
					});
				}      
			})
		},
		dealerfocus(){//获取经销商
			this.dealerVisible=true;
		},
		dealerconfirm(scope){ //选中仓库
			this.form.OutboundOrder.ReceiverId = scope.row.DealerId;
			this.form.DealerName = scope.row.DealerName;
			this.dealerVisible = false
		},
		setDealerNull(){
			this.form.OutboundOrder.ReceiverId = '';
		},

		restForm(){//重置表单
			this.$nextTick(()=>{
				this.$refs['form'].resetFields()
			})
			this.form.OutboundOrder.Productcode = '';
			this.form.OutboundOrder.ReceiverId = '';
			this.form.OutboundOrder.ShipperId ='';
		},
		
		SeloutData(){
			this.$refs['form'].validate((isValidate)=>{
				if(isValidate){
					var user = JSON.parse(sessionStorage.getItem('user'));
					this.$axios({
						method: 'post',
						url:'/FW/OutData.ashx',
						params: {
							action:"SeloutData",
							CID:user.QyNum,
							OutboundOrder:this.form.OutboundOrder,
							outTime:this.form.outTime,
							pageIndex:this.form.pageIndex
						}
						}).then(res=>{
						if(res.Code==0){
							this.pageNum=res.Data.Total;
							this.tableData=res.Data.DataList;
						}else{
							this.$message({
							showClose: true,
							message: res.Msg,
							type: "warning"
							});
						}      
					})
				}else{
					isValidate
				}
			})
			
		},
		handleCurrentChange(index){
			this.form.pageIndex=index;
			this.SeloutData()
		},
		date_string(row) {
			var str=row.OutTime;
			var d = eval('new ' + str.substr(1, str.length - 2));
			var ar_date = [d.getFullYear(), d.getMonth() + 1, d.getDate() ];
			var ar_time = [d.getHours(), d.getMinutes(), d.getSeconds()];
			for (var i = 0; i < ar_date.length; i++) ar_date[i] = dFormat(ar_date[i]);
			for (var i = 0; i < ar_time.length; i++) ar_time[i] = dFormat(ar_time[i]);
			return ar_date.join('-')+" "+ar_time.join(':');

			function dFormat(i) { return i < 10 ? "0" + i.toString() : i; }
		},
	}
}
</script>

<style scoped>
.title{
  text-align: left;
}
.btn{
	margin:0 0 10px 30px;
}
.el-select{
	display: inline;
}
</style>


// WEBPACK FOOTER //
// src/pages/outData.vue